import { motion } from 'framer-motion'

import { Close, HiLoSignInToPlayCSS } from './HiLoSignInToPlayCSS.styled'
import { useWalletConnection } from 'hooks/useWalletConnection'
import { useUser } from 'hooks/user/useUser'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

import { useNavigate } from 'react-router-dom'

export const HiLoSignInToPlay = ({ layoutId, onClose }) => {
  const navigateTo = useNavigate()
  const { connectWallet, disconnectWallet } = useWalletConnection()
  const { isAllowed } = useUser('allowed')
  const { isConnected } = useUser('wallet')

  const onConnectWallet = () => {
    if (isConnected) return
    if (isAllowed) {
      navigateTo(`/game/${CONTENT_TYPES.RESTRICTED}`)
      disconnectWallet()
      return
    }
    connectWallet()
  }
  return (
    <HiLoSignInToPlayCSS>
      <motion.div layoutId={layoutId} className='overlay'>
        <Close masking onClick={onClose} />
        <button onClick={onConnectWallet}>Sign in to play</button>
      </motion.div>
    </HiLoSignInToPlayCSS>
  )
}
